import styled from 'styled-components';
import { lightThemeObject } from "../../../styleguide";
export var Container = styled.div.withConfig({
  displayName: "BigAssCategoryPickerstyles__Container",
  componentId: "sc-17t4yfa-0"
})(["display:inline-block;"]);
export var MenuPositioner = styled.div.withConfig({
  displayName: "BigAssCategoryPickerstyles__MenuPositioner",
  componentId: "sc-17t4yfa-1"
})(["position:absolute;width:100%;background-color:transparent;left:0;right:0;top:100%;"]);
export var Frame = styled.div.withConfig({
  displayName: "BigAssCategoryPickerstyles__Frame",
  componentId: "sc-17t4yfa-2"
})(["background:var(--bui-background,", ");border-top:1px solid var(--bui-border,", ");box-shadow:0px 4px 6px 0px rgba(54,52,51,0.15);outline:0;"], lightThemeObject['--bui-background'], lightThemeObject['--bui-border']);
//# sourceMappingURL=BigAssCategoryPicker.styles.js.map